<template>
  <footer>
    <cookie-law theme="cityhub" buttonText="Aceito">
        <div slot="message">
            Este website utiliza cookies. Ao continuar a navegação está a aceitar a sua utilização. Caso pretenda saber mais,
            consulte a nossa <router-link :to="routerLink(getSlugPageType('privacy'))">política de privacidade</router-link>.
        </div>
    </cookie-law>
  </footer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CookieLaw from 'vue-cookie-law';
    import GlobalMixin from '@/app/shared/mixins/global';


    export default {
        mixins: [GlobalMixin],
        components: { CookieLaw },
        methods: {
            routerLink: function(slug) {
				return this.getRouterLinkFromPage(null, {slug});
			},
        },
        computed: {
            ...mapGetters({
                getSlugPageType: 'getSlugPageType',
            }),
        }
    }
</script>

<style lang="scss">
@import "@styles/_theme.scss";

.Cookie--cityhub {
    background: $primary-color;
    color: $white;
    padding: 1.25em;

    .Cookie__content {
        a {
            text-decoration: underline !important;
            color: inherit;
        }
    }

    .Cookie__button {
        background: $primary-color;
        padding: 0.625em 3.125em;
        color: $white;
        border-radius: $btn-radius;
        border: 2px solid $white;
        font-size: 1em;
        outline: none;

        &:hover {
            background: darken($primary-color, 10%);
        }
    }

    .Cookie__button--decline {
        background: transparent;
        padding: 0.625em 3.125em;
        color: darken($primary-color, 50%);
        border-radius: $btn-radius;
        border: 2px solid $white;
        font-size: 1em;

        &:hover {
            background: darken($primary-color, 15%);
        }
    }
}

</style>
